import api from "@/services/api";

export default {
    currentUser
};


export async function currentUser() {
    const response = await api.get("/Auth/CurrentUser");
    const user = response.data;
    return !user ? null : user;
}
